/* eslint-disable @typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars */

xplenty.directive('cubeEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./cube-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        '$timeout',
        '$translate',
        function ($scope, $timeout, $translate) {
          $scope.cubeCollectionSettings = {
            outsideSourceValidation: {
              unique: {
                validation: [],
                message: $translate.instant('aggregate-editor.form.errors.duplicate_fields'),
              },
            },
          };

          $scope.aggregateCollectionSettings = {
            outsideSourceValidation: {
              unique: {
                validation: [],
                message: $translate.instant('aggregate-editor.form.errors.duplicate_fields'),
              },
            },
          };

          $scope.onGroupedRecordsChange = (records) => {
            $scope.component.grouped_fields = records;
          };

          $scope.onAggregatedRecordsChange = (records) => {
            $scope.component.aggregated_fields = records;
          };

          $scope.onCubeValidityChange = (isValid) => {
            $scope.cubeValidity = isValid;
          };

          $scope.onAggregateValidityChange = (isValid) => {
            $scope.aggregateValidity = isValid;
          };

          $scope.$watch('[cubeValidity, aggregateValidity]', function () {
            const valid = $scope.cubeValidity && $scope.aggregateValidity;
            $scope.onValidityChange(valid);
          });

          $scope.$watch(
            'component.grouped_fields',
            function (records) {
              $scope.aggregateCollectionSettings.outsideSourceValidation.unique.validation = _.flatten(
                _.pluck(records, 'fields'),
              );
              $scope.aggregateCollectionSettings = { ...$scope.aggregateCollectionSettings };
            },
            true,
          );

          $scope.$watch(
            'component.aggregated_fields',
            function (records) {
              $scope.cubeCollectionSettings.outsideSourceValidation.unique.validation = _.pluck(records, 'alias');
              $scope.cubeCollectionSettings = { ...$scope.cubeCollectionSettings };
            },
            true,
          );
        },
      ],
    };
  },
]);
